import Link from 'next/link'
import ReactDOMServer from 'react-dom/server'
import { ChangeEvent, useState } from 'react'
import styles from './faqView.module.css'

type Faq = {
  title: JSX.Element,
  body: JSX.Element[],
}

type FaqProcessed = Faq & {
  titleString: string,
  bodyString: string,
}

const faqData: Faq[] = [
  {
    title: <h3>What is&nbsp;CardHero?</h3>,
    body: [<p>CardHero is the ridiculously easy way to get a great card for your anniversary, your partner’s birthday, or any time you want to make someone feel&nbsp;special.</p>,
    <p>Spend four minutes on your phone or computer now and schedule a great card for delivery to your mailbox right when you need it. Since CardHero's AI-powered recommendation engine learns what style of card you want for a particular recipient, it takes even less time next year.</p>],
  }, {
    title: <h3>What’s so bad about the card&nbsp;aisle?</h3>,
    body: [<p>If you love the card aisle, that is great! My experience has always been negative. The cards are bland and awkward, with limited selection and surprising prices. Plus, I often forget to go until the last minute. I believe that buying a card should be a simple, enjoyable experience.</p>],
  }, {
    title: <h3>Why buy a card instead of making my&nbsp;own?</h3>,
    body: [<p>Please, please consider making your own card! Handmade cards can be amazing and carry so much meaning. Even a hand-written note on a nice piece of paper can be more powerful than any store-bought card. On the other hand, if you are going to buy a card, I hope you’ll consider buying from CardHero!</p>],
  }, {
    title: <h3>Why is CardHero better than an&nbsp;e-card?</h3>,
    body: [<p>CardHero mails you a real, high-quality paper card that your recipient can hold in their hands. You want to send a meaningful message, and an e-card comes off as cheap. CardHero aims to be the best way for you to get a great card easily.</p>],
  }, {
    title: <h3>Why are most of your cards <em>blank</em> on the&nbsp;inside?!?</h3>,
    body: [<p>The point of a card is to make someone feel special, and taking a few minutes to write your own message makes the card more meaningful to the recipient.</p>],
  }, {
    title: <h3>Who built CardHero?</h3>,
    body: [<p>Hi! I’m Matt and I built CardHero. You can <Link href='/about'><a>learn more about me</a></Link> if, for some reason, that appeals to you.</p>],
  }, {
    title: <h3>Do you design the&nbsp;cards?</h3>,
    body: [<p>No, I work with talented, independent card designers. They write and design cards that go beyond the clichés you find in the card aisle of your local convenience store.</p>],
  }, {
    title: <h3>Should I care that CardHero is such a small&nbsp;company?</h3>,
    body: [
      <p>When you think about Valentine’s, anniversary, or birthday cards, you probably first think of one or two very LARGE corporations. CardHero is different, and I think our small size benefits you.</p>,
      <p>Here are a few reasons why:</p>,
      <ul>
        <li>I care about you having a great experience: honestly, the idea of disappointing you as a customer gives me anxiety</li>
        <li>I care about the planet we live on and I think companies should give back</li>
        <li>I will be the one who hears from you if you’re not happy or want your money back</li>
      </ul>
    ],
  }
]

const faqDataProcessed: FaqProcessed[] = faqData.map((faq) => ({
    title: faq.title,
    body: faq.body,
    titleString: ReactDOMServer.renderToString(faq.title).toLowerCase(),
    bodyString: faq.body.map(faqBody => ReactDOMServer.renderToString(faqBody)).join(' ').toLowerCase(),
}))

const FaqView = () => {
  const [searchTerm, setSearchTerm] = useState('')
  const handleSearchTextChange = (event: ChangeEvent<HTMLInputElement>) => {
    const text = event?.target?.value
    setSearchTerm(text)
  }
  const faqContainsSearchTerm = (faq: FaqProcessed, searchTerm: string) => {
    if (searchTerm === '') return true
    const searchTermLower = searchTerm.toLowerCase()
    console.log({
      titleString: faq.titleString,
      bodyString: faq.bodyString,
      searchTerm,
      isMatch: faq.titleString.includes(searchTermLower) || faq.bodyString.includes(searchTermLower),
    })
    return faq.titleString.includes(searchTermLower) || faq.bodyString.includes(searchTermLower)
  }

  const faqsDisplayed = faqDataProcessed
    .filter(faq => faqContainsSearchTerm(faq, searchTerm))
    .map(faq =>
      <div key={faq.titleString} className={styles.faq}>
        { faq.title }
        { faq.body }
      </div>)

  return <>
    <div className={styles.heading}>
      <h1>FAQs</h1>
      <input className={styles.searchField} type='text' onChange={handleSearchTextChange} placeholder='Search FAQs' />
    </div>
    {
      faqsDisplayed.length > 0
        ? faqsDisplayed
        : <div>No matching FAQs found</div>
    }
  </>
}

export default FaqView
